import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=6658ca74&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=6658ca74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658ca74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6658ca74')) {
      api.createRecord('6658ca74', component.options)
    } else {
      api.reload('6658ca74', component.options)
    }
    module.hot.accept("./PageTitle.vue?vue&type=template&id=6658ca74&scoped=true", function () {
      api.rerender('6658ca74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/PageTitle.vue"
export default component.exports